import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  ({ palette, spacing, mlbCustomVariables, themeName, breakpoints }) => ({
    container: {
      marginTop: spacing(6)
    },
    paragraph: {
      color: palette.primary.contrastText,
      flex: 2,
      textAlign: 'left',
      ...(themeName === 'dacia' && {
        fontSize: 18,
        lineHeight: '24px'
      })
    },
    btnBox: {
      background: palette.primary.main,
      color: palette.primary.contrastText,
      padding: spacing(3.75),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: spacing(2),
      flexDirection: 'column',
      [breakpoints.up('sm')]: {
        flexDirection: 'row'
      }
    },
    faqButton: {
      flex: 1,
      color: palette.primary.bodyText,
      backgroundColor: palette.primary.contrastText,
      fontSize: spacing(2.5),
      fontWeight: 700,
      fontFamily: mlbCustomVariables.primaryFont,
      ...(themeName === 'dacia' && {
        fontSize: 14,
        fontFamily: 'Read',
        color: palette.primary.main
      }),
      '&:hover': {
        backgroundColor: palette.secondary.main,
        ...(themeName === 'dacia' && {
          color: palette.common.white,
          backgroundColor: palette.common.black
        })
      },
      '@media (hover: none)': {
        '&:hover': {
          color: palette.primary.bodyText,
          backgroundColor: palette.primary.contrastText,
          ...(themeName === 'dacia' && {
            color: palette.primary.main
          })
        }
      }
    }
  })
);
